// extracted by mini-css-extract-plugin
export default {"successText":"SubscriptionGiftSuccessPage_successText__ANQTM","successImg":"SubscriptionGiftSuccessPage_successImg__cKelH","container":"SubscriptionGiftSuccessPage_container__Zo7-K"};